import React, { useState, useEffect } from "react";
import { Box, TextField, FormControl, FormControlLabel, Switch,Alert } from "@mui/material";
import { useTranslation } from "react-i18next";
import { IntegrationSystemViewModel, IntegrationSettingsViewModel } from "../../../Types/ExportTypes";
type IntegrationProps = {
    viewModel: IntegrationSystemViewModel;
    setViewModel: React.Dispatch<React.SetStateAction<IntegrationSystemViewModel>>;
};


const VoyadoIntegration: React.FC<IntegrationProps> = ({ viewModel, setViewModel }) => {
    const { t } = useTranslation();

    const [apiKey, setApiKey] = useState("");
    const [host, setHost] = useState("");
    const [ftpUsername, setFtpUsername] = useState("");
    const [ftpPassword, setFtpPassword] = useState("");
    const [ftpPath, setFtpPath] = useState("");
    const [voyadoAwardsBonus, setVoyadoAwardsBonus] = useState(false);
    useEffect(() => {
        if (viewModel.tag !== "Voyado") {
            setViewModel(prev => ({
                ...prev, tag: "Voyado", legacyInvoiceBilled: true, active: true, settings:
                    [{ key: "SkipB2bCustomer", value: "True", propertyType: "bool" }]
            }));
        }
    }, [viewModel.tag, setViewModel]);


    const setSetting = (key: string, value: string) => {
        setViewModel(prev => {
            const settings = prev.settings ? [...prev.settings] : [];

            const idx = settings.findIndex(s => s.key === key);

            if (idx >= 0) {
                // update existing
                settings[idx] = { ...settings[idx], value };
            } else {
                // add new
                settings.push({
                    key,
                    value,
                    integrationId: prev.id ?? null,
                });
            }

            return { ...prev, settings };
        });
    };
    return (
        <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>

            <TextField
                fullWidth
                label={t("common.description")}
                value={viewModel.description}
                onChange={(e) => setViewModel({ ...viewModel, description: e.target.value })}
                InputLabelProps={{ shrink: true }}
            />


            <TextField
                fullWidth
                label={"Url"}
                value={viewModel.serviceUrl1}
                onChange={(e) => setViewModel({ ...viewModel, serviceUrl1: e.target.value })}
                InputLabelProps={{ shrink: true }}
            />


            <TextField
                label="Apikey"
                value={apiKey}
                onChange={(e) => {
                    const val = e.target.value;
                    setApiKey(val);
                    setSetting("Apikey", val);
                }}
                InputLabelProps={{ shrink: true }}
            />


            <FormControlLabel
                control={
                    <Switch
                        checked={voyadoAwardsBonus === true}
                        onChange={(e) => {
                            const checked = e.target.checked;

                            // Update local state
                            setVoyadoAwardsBonus(checked ? true : false);

                            // Only persist the value if it's true
                            if (checked) {
                                setSetting("VoyadoAwardsBonus", "true");
                            }
                            else setSetting("VoyadoAwardsBonus", "false");
                        }}
                    />
                }
                label="Voyado Award Bonus"
            />

            <Alert severity="info" sx={{ mb: 2 }}>
                This setting + Ftp enables voucher import from voyado into BeX. Get more information from Voyado.
            </Alert>


            <TextField
                label="FtP Host"
                value={host}
                onChange={(e) => {
                    const val = e.target.value;
                    setHost(val);
                    setSetting("FtpHost", val);
                }}
                InputLabelProps={{ shrink: true }}
            />

            <TextField
                label="FTP Username"
                value={ftpUsername}
                onChange={(e) => {
                    const val = e.target.value;
                    setFtpUsername(val);
                    setSetting("FtpUsername", val);
                }}
                InputLabelProps={{ shrink: true }}
            />

            <TextField
                label="FTP Password"
                value={ftpPassword}
                onChange={(e) => {
                    const val = e.target.value;
                    setFtpPassword(val);
                    setSetting("FtpPassword", val);
                }}
                InputLabelProps={{ shrink: true }}
            />



            <TextField
                label="FTP Path"
                value={ftpPath}
                onChange={(e) => {
                    const val = e.target.value;
                    setFtpPath(val);
                    setSetting("FtpPath", val);
                }}
                InputLabelProps={{ shrink: true }}
            />








        </Box>
    );
};


export default VoyadoIntegration;
